export const MAX_SPAN = 24
export const ROW_GUTTER = 16
